export const LAST_CONFIGURATION_ID_LOCAL_STORAGE_KEY =
  'pl-analyze-last-configuration-id';
export const SHOW_SUPER_RES_BADGE_LOCAL_STORAGE_KEY = 'pl-show-super-res-badge';

export enum MOSAICKING_ORDER {
  mostRecent = 'mostRecent',
  leastRecent = 'leastRecent',
  leastCC = 'leastCC',
}
export enum INTERPOLATOR {
  bilinear = 'BILINEAR',
  bicubic = 'BICUBIC',
  lanczos = 'LANCZOS',
  box = 'BOX',
  nearest = 'NEAREST',
}

export const SUPER_RES_LAYER_ID = 'super-res';
export const SUPER_RES_RESOLUTION = 3;
export const MAX_SUPER_RES_IMAGE_SIZE_IN_PIXELS = 3e6;
export const MAX_PROCESS_API_SIZE_PER_SIDE = 2500;
